<!-- <app-pdf-viewer [src]="src"></app-pdf-viewer> -->
<div class="container-fluid box-detail p-0 m-0">
    <mat-dialog-actions>
      <button class="btn close" type="button" mat-dialog-close></button>
    </mat-dialog-actions>
    <div class="page-content p-0">
      <div class="header">Privacy Policy</div>
      <app-pdf-viewer [src]="src"></app-pdf-viewer>
    </div>
  </div>
